// UDOMI-487: Work Order Traveler — Task Tracker service

import { ApiService } from '../../api/api-service';
import { TaskTrackerRequest, TaskTrackerResponse, TravelerData } from '../../types';

const SERVICE_ROOT = '/task-trackers';
const ORDER_ROOT = '/order';

/**
 * Service for task tracker and traveler-related API operations
 */
export class TaskTrackerService extends ApiService {
  /**
   * Get the Work Order Traveler composite data for an order
   * @param orderId Order ID
   * @returns Promise resolving to the traveler composite response
   */
  async getTravelerData(orderId: number): Promise<TravelerData> {
    return this.handleApiCall(
      () => this.client.get(`${ORDER_ROOT}/${orderId}/traveler`),
      `Error fetching traveler data for order ${orderId}`
    );
  }

  /**
   * Create a new task tracker stage (first save for a virtual stage)
   * @param request Create request payload
   * @returns Promise resolving to the created task tracker
   */
  async createTaskTracker(request: TaskTrackerRequest): Promise<TaskTrackerResponse> {
    return this.handleApiCall(
      () => this.client.post(SERVICE_ROOT, request),
      'Error creating task tracker'
    );
  }

  /**
   * Update a task tracker stage
   * @param id Task tracker ID
   * @param request Update request payload
   * @returns Promise resolving to the updated task tracker
   */
  async updateTaskTracker(id: number, request: TaskTrackerRequest): Promise<TaskTrackerResponse> {
    return this.handleApiCall(
      () => this.client.put(`${SERVICE_ROOT}/${id}`, request),
      `Error updating task tracker ${id}`
    );
  }
}
